import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  quarterOptions: null,
  quarter: null,
  playerPointSelect: false,
  playerSelect: true,
  made1PT: true,
  made2PT: true,
  made3PT: true,
  miss1PT: true,
  miss2PT: true,
  miss3PT: true,
  toPT: true,
  foul: false,
  foulPT: false,
  foulActions: true,
  toActions: true,
  starAction: true,
  teamOneSections: false,
  teamTwoSections: false,
  shortSelections: false,
  shortFieldSelections: false,
  playerControlSelections: true,
  assistSelections: false,
  reboundSelections: false,
  turnoverSelections: false,
  foulSelections: false,
  foulActionsSelections: false,
  actionPlayerId: null,
  assistPlayerId: null,
  playerSelectionsTeamOne: false,
  playerSelectionsTeamTwo: false,
  madePT: false,
  missPT: false,
  actionSteps: 1,
  game_data: null,
  point1: null,
  point2: null,
  point3: null,
  pointMiss1: null,
  pointMiss2: null,
  pointMiss3: null,
  assistPoint: null,
  turnoverPoint: null,
  reboundBlockPoint: null,
  foulPoint: null,
  teamOneColor: "#419066",
  teamTwoColor: "#EA9036",
  matchStatus: "Waiting to start",
  reset: false,
  scoreTemporaryData: [],
  postingData: [],
  cancelStep: 1,
  sl_no: 1,
  scoreDeleteLoading: false,
  teamOneTargetPlayerList: [],
  teamTwoTargetPlayerList: [],
  teamOneDraggedPlayerList: [],
  teamTwoDraggedPlayerList: [],
  undoStep: 0,
  teamOneOfficial: [],
  teamTwoOfficial: [],
  possessionArrowTeamOne: false,
  possessionArrowTeamTwo: false,
  shotClock: false,
  shotClockValue: 24,
  shotClockReset1: 24,
  shotClockReset2: 14,
  timeout: false,
  openStarterModal: false,
  eventType:'5x5',
  // Jump ball players (decoupled from starting lineup "starter" flags)
  jumpBallTeamAPlayerRosterId: null,
  jumpBallTeamBPlayerRosterId: null,

};

const playersSlice = createSlice({
  name: 'players',
  initialState,
  reducers: {
    submitPlayersAndMatchData: (state, action) => {

      state.matchData = { ...action.payload };
      state.cancelStep += 1;
    },
    submitPlayersAndMatchDataWithOutPlaySec: (state, action) => {
      const { team_a_rosters, team_b_rosters } = state.matchData;

      state.matchData = {
        ...state.matchData,
        ...action.payload,
        team_a_rosters: team_a_rosters.map(player => ({
          ...action.payload.team_a_rosters.find(p => p.roster_id === player.roster_id),
          play_sec: player.play_sec
        })),
        team_b_rosters: team_b_rosters.map(player => ({
          ...action.payload.team_b_rosters.find(p => p.roster_id === player.roster_id),
          play_sec: player.play_sec
        }))
      };
    },
    made2PT: (state) => {
      state.made2PT = "active";
      state.made1PT = false;
      state.made3PT = false;
      state.miss1PT = false;
      state.miss2PT = false;
      state.miss3PT = false;
      state.foulActions = false;
      state.toActions = false;
      state.playerPointSelect = true;
      state.madePT = true;
      state.actionSteps += 1;
      state.point2 = true;
      state.cancelStep += 1;
      state.undoStep += 2;
    },
    made3PT: (state) => {
      state.made2PT = false;
      state.made1PT = false;
      state.made3PT = "active";
      state.miss1PT = false;
      state.miss2PT = false;
      state.miss3PT = false;
      state.foulActions = false;
      state.toActions = false;
      state.playerPointSelect = true;
      state.madePT = true;
      state.actionSteps += 1;
      state.point3 = true;
      state.cancelStep += 1;
      state.undoStep += 2;
    },
    made1PT: (state) => {
      state.made2PT = false;
      state.made1PT = "active";
      state.made3PT = false;
      state.miss1PT = false;
      state.miss2PT = false;
      state.miss3PT = false;
      state.foulActions = false;
      state.toActions = false;
      state.playerPointSelect = true;
      state.madePT = true;
      state.actionSteps += 1;
      state.point1 = true;
      state.cancelStep += 1;
      state.undoStep += 2;
    },
    miss2PT: (state) => {
      state.made2PT = false;
      state.made1PT = false;
      state.made3PT = false;
      state.miss1PT = false;
      state.miss2PT = "active";
      state.miss3PT = false;
      state.foulActions = false;
      state.toActions = false;
      state.playerPointSelect = true;
      state.missPT = true;
      state.actionSteps += 1;
      state.pointMiss2 = true;
      state.cancelStep += 1;
      state.undoStep += 2;
    },
    miss3PT: (state) => {
      state.made2PT = false;
      state.made1PT = false;
      state.made3PT = false;
      state.miss1PT = false;
      state.miss2PT = false;
      state.miss3PT = "active";
      state.foulActions = false;
      state.toActions = false;
      state.playerPointSelect = true;
      state.missPT = true;
      state.actionSteps += 1;
      state.pointMiss3 = true;
      state.cancelStep += 1;
      state.undoStep += 2;
    },
    miss1PT: (state) => {
      state.made2PT = false;
      state.made1PT = false;
      state.made3PT = false;
      state.miss1PT = "active";
      state.miss2PT = false;
      state.miss3PT = false;
      state.foulActions = false;
      state.toActions = false;
      state.playerPointSelect = true;
      state.missPT = true;
      state.actionSteps += 1;
      state.pointMiss1 = true;
      state.cancelStep += 1;
      state.undoStep += 2;
    },
    toPT: (state) => {
      state.made2PT = false;
      state.made1PT = false;
      state.made3PT = false;
      state.miss1PT = false;
      state.miss2PT = false;
      state.miss3PT = false;
      state.foulActions = false;
      state.toActions = "active";
      state.playerPointSelect = true;
      state.foul = true;
      state.actionSteps += 1;
      state.cancelStep += 1;
      state.undoStep += 2;
    },
    foulActions: (state) => {
      state.made2PT = false;
      state.made1PT = false;
      state.made3PT = false;
      state.miss1PT = false;
      state.miss2PT = false;
      state.miss3PT = false;
      state.foulActions = "active";
      state.toActions = false;
      state.playerPointSelect = true;
      state.foul = false;
      state.foulPT = true;
      state.actionSteps += 1;
      state.cancelStep += 1;
      state.undoStep += 2;
    },
    playerSelectionTeamOne: (state, action) => {
      state.playerControlSelections = action.payload.playerControlSelections;
      state.actionPlayerId = action.payload.actionPlayerId;
      state.shortSelections = action.payload.shortSelections;
      state.playerSelectionsTeamOne = action.payload.playerSelectionsTeamOne;
      state.shortFieldSelections = action.payload.shortFieldSelections;
      state.playerPointSelect = action.payload.playerPointSelect;
      state.made2PT = action.payload.made2PT;
      state.made1PT = action.payload.made1PT;
      state.made3PT = action.payload.made3PT;
      state.miss1PT = action.payload.miss1PT;
      state.miss2PT = action.payload.miss2PT;
      state.miss3PT = action.payload.miss3PT;
      state.foulActions = action.payload.foulActions;
      state.toActions = action.payload.toActions;
      state.assistSelections = action.payload.assistSelections;
      state.reboundSelections = action.payload.reboundSelections;
      state.turnoverSelections = action.payload.turnoverSelections;
      // state.playerSelectionsTeamTwo = action.payload.playerSelectionsTeamTwo; // Uncomment if needed
      state.foulActionsSelections = action.payload.foulActionsSelections;
      state.actionSteps += 1;
      state.point1 = action.payload.point1;
      state.point2 = action.payload.point2;
      state.point3 = action.payload.point3;
      state.pointMiss1 = action.payload.pointMiss1;
      state.pointMiss2 = action.payload.pointMiss2;
      state.pointMiss3 = action.payload.pointMiss3;
      state.assistPoint = action.payload.assistPoint;
      state.reboundBlockPoint = action.payload.reboundBlockPoint;
      state.turnoverPoint = action.payload.turnoverPoint;
      state.foulPoint = action.payload.foulPoint;
      state.cancelStep += 1;
      // state.undoStep += 1;
    },

    playerSelectionTeamOneMiss: (state, action) => {
      Object.assign(state, action.payload);
      state.actionSteps += 1;
      state.cancelStep += 1;
    },
    playerSelectionTeamTwo: (state, action) => {
      state.playerControlSelections = action.payload.playerControlSelections;
      state.actionPlayerId = action.payload.actionPlayerId;
      state.shortSelections = action.payload.shortSelections;
      state.playerSelectionsTeamTwo = action.payload.playerSelectionsTeamTwo;
      state.shortFieldSelections = action.payload.shortFieldSelections;
      state.playerPointSelect = action.payload.playerPointSelect;
      state.made2PT = action.payload.made2PT;
      state.made1PT = action.payload.made1PT;
      state.made3PT = action.payload.made3PT;
      state.miss1PT = action.payload.miss1PT;
      state.miss2PT = action.payload.miss2PT;
      state.miss3PT = action.payload.miss3PT;
      state.foulActions = action.payload.foulActions;
      state.toActions = action.payload.toActions;
      state.assistSelections = action.payload.assistSelections;
      state.reboundSelections = action.payload.reboundSelections;
      state.turnoverSelections = action.payload.turnoverSelections;
      state.foulActionsSelections = action.payload.foulActionsSelections;
      state.point1 = action.payload.point1;
      state.point2 = action.payload.point2;
      state.point3 = action.payload.point3;
      state.pointMiss1 = action.payload.pointMiss1;
      state.pointMiss2 = action.payload.pointMiss2;
      state.pointMiss3 = action.payload.pointMiss3;
      state.assistPoint = action.payload.assistPoint;
      state.reboundBlockPoint = action.payload.reboundBlockPoint;
      state.turnoverPoint = action.payload.turnoverPoint;
      state.foulPoint = action.payload.foulPoint;
      state.actionSteps += 1;  // Increment the actionSteps after all assignments
      state.cancelStep += 1;
    },

    playerSelectionTeamTwoMiss: (state, action) => {
      Object.assign(state, action.payload);
      state.actionSteps += 1;
      state.cancelStep += 1;
    },
    shortFieldSelection: (state, action) => {
      Object.assign(state, action.payload);
      state.actionSteps += 1;
      state.shortFieldSelections = state.shortFieldSelections;
      state.shortSelections = state.shortSelections;
    },
    playerAssistSection: (state, action) => {
      Object.assign(state, action.payload);
      state.actionSteps += 1;
      state.shortSelections = false;
      state.shortFieldSelections = false;
    },
    playerRebound: (state) => {
      state.actionSteps += 1;
      state.cancelStep += 1;
    },
    playerAssistSelection: (state, action) => {

      state.assistSelections = false;
      state.playerControlSelections = true;
      state.actionPlayerId = null;
      state.playerPointSelect = false;
      state.assistPlayerId = action.payload; // Keeping this from action payload
      state.made2PT = true;
      state.made1PT = true;
      state.made3PT = true;
      state.miss1PT = true;
      state.miss2PT = true;
      state.miss3PT = true;
      state.foulActions = true;
      state.toActions = true;
      state.playerSelectionsTeamOne = false;
      state.playerSelectionsTeamTwo = false;
      state.missPT = false;
      state.madePT = false;
      state.reboundSelections = false;
      state.turnoverSelections = false;
      state.foulActionsSelections = false;
      state.actionSteps = 1;
      state.point1 = null;
      state.point2 = null;
      state.point3 = null;
      state.pointMiss1 = null;
      state.pointMiss2 = null;
      state.pointMiss3 = null;
      state.assistPoint = null;
      state.reboundBlockPoint = null;
      state.turnoverPoint = null;
      state.foulPoint = null;
      state.foul = false;
      state.foulPT = false;
      state.cancelStep = 1;
      state.shortFieldSelections = false;
      state.shortSelections = false;
      state.undoStep = 0;
    },

    teamOnePlayerDrop: (state, action) => {
      const { draggedPlayer, targetPlayer } = action.payload;
      const updatedTeamOneData = state?.matchData?.team_a_rosters.map((player) =>
        player.roster_id === draggedPlayer
          ? { ...player, is_Playing: true }
          : player.roster_id === targetPlayer
            ? { ...player, is_Playing: false }
            : player
      );
      state.matchData.team_a_rosters = [...updatedTeamOneData];
    },
    teamTwoPlayerDrop: (state, action) => {
      const { draggedTeamTwoPlayer, targetTeamTwoPlayer } = action.payload;
      const updatedTeamTwoData = state.matchData.team_b_rosters.map((player) =>
        player.roster_id === draggedTeamTwoPlayer
          ? { ...player, is_Playing: true }
          : player.roster_id === targetTeamTwoPlayer
            ? { ...player, is_Playing: false }
            : player
      );
      state.matchData.team_b_rosters = [...updatedTeamTwoData];
    },
    gameData: (state, action) => {

      state.matchData.game_data = { ...action.payload };
      state.cancelStep += 1;
    },
    gameSubs: (state, action) => {
      state.matchData.game_subs = [...action.payload];
    },
    startAction: (state, action) => {
      state.starAction = action.payload;
    },
    resetTeamOnePlaying: (state) => {
      state.matchData.team_a_rosters = state?.matchData?.team_a_rosters?.map((player) => ({
        ...player,
        is_Playing: false,
      }));
    },
    resetTeamTwoPlaying: (state) => {
      state.matchData.team_b_rosters = state.matchData.team_b_rosters.map((player) => ({
        ...player,
        is_Playing: false,
      }));
    },
    updateTeamOnePlayerPlayingStatus: (state, action) => {
      const updatedTeamARosters = state.matchData.team_a_rosters.map((player) => {
        const payloadPlayer = action.payload.find(
          (payloadPlayer) => payloadPlayer.roster_id === player.roster_id
        );
        if (payloadPlayer) {
          return {
            ...player,
            is_Playing: payloadPlayer.is_Playing,
          };
        } else {
          return player;
        }
      });

      const updatedTeamARostersFinal = updatedTeamARosters.map((player) => ({
        ...player,
        is_Playing: action.payload.some(
          (payloadPlayer) => payloadPlayer.roster_id === player.roster_id
        )
          ? player.is_Playing
          : false,
      }));

      // Update matchData with the new team_a_rosters array
      state.matchData.team_a_rosters = updatedTeamARostersFinal;
    },
    updateTeamTwoPlayerPlayingStatus: (state, action) => {
      // Map through the team_b_rosters to update players' playing status
      const updatedTeamBRosters = state.matchData.team_b_rosters.map((player) => {
        const payloadPlayer = action.payload.find(
          (payloadPlayer) => payloadPlayer.roster_id === player.roster_id
        );
        if (payloadPlayer) {
          return {
            ...player,
            is_Playing: payloadPlayer.is_Playing,
          };
        } else {
          return player;
        }
      });

      // Final adjustment to ensure that all other players are set to false for is_Playing
      const updatedTeamBRostersFinal = updatedTeamBRosters.map((player) => ({
        ...player,
        is_Playing: action.payload.some(
          (payloadPlayer) => payloadPlayer.roster_id === player.roster_id
        )
          ? player.is_Playing
          : false,
      }));

      // Update the state directly with the new team_b_rosters
      state.matchData.team_b_rosters = updatedTeamBRostersFinal;
    },
    updateTeamOneLastPlayerIsPlaying: (state, action) => {
      state.matchData.team_a_rosters = state.matchData.team_a_rosters.map((player) => {
        if (player.roster_id === action.payload.playerCode) {
          return {
            ...player,
            is_Playing: action.payload.newPlayingStatus,
          };
        }
        return player;
      });
    },
    updateTeamTwoLastPlayerIsPlaying: (state, action) => {
      state.matchData.team_b_rosters = state.matchData.team_b_rosters.map((player) => {
        if (player.roster_id === action.payload.playerCode) {
          return {
            ...player,
            is_Playing: action.payload.newPlayingStatus,
          };
        }
        return player;
      });
    },
    updateCancelTeamOnePlayerPlayingStatus: (state, action) => {
      // Set all players to not playing
      const allPlayerPlayingFalse = state.matchData.team_a_rosters.map((player) => ({
        ...player,
        is_Playing: false,
      }));

      // Update players that match the payload to be playing
      const updatedCancelTeamOneData = allPlayerPlayingFalse.map((player) => {
        if (action.payload.find((item) => item.code === player.roster_id)) {
          return { ...player, is_Playing: true };
        }
        return player;
      });

      // Update the state directly using Redux Toolkit's immer-powered mutation
      state.matchData.team_a_rosters = updatedCancelTeamOneData;
    },
    updateCancelTeamTwoPlayerPlayingStatus: (state, action) => {
      // First set all players' is_Playing to false
      const teamTwoAllPlayerPlayingFalse = state.matchData.team_b_rosters.map(
        (player) => {
          return {
            ...player,
            is_Playing: false, // Reset all to false initially
          };
        }
      );

      // Then update players whose roster_id matches the payload to is_Playing: true
      const updatedCancelTeamTwoData = teamTwoAllPlayerPlayingFalse.map((player) => {
        if (action.payload.find((item) => item.code === player.roster_id)) {
          return { ...player, is_Playing: true };
        } else {
          return player;
        }
      });

      // Update the state with the new team_b_rosters
      state.matchData.team_b_rosters = updatedCancelTeamTwoData;
    },
    quarterOptions: (state, action) => {
      state.quarterOptions = action.payload;
    },
    selectedQuarter: (state, action) => {
      state.quarter = action.payload;
    },
    teamOneColorSet: (state, action) => {
      state.teamOneColor = action.payload;
    },
    teamTwoColorSet: (state, action) => {
      state.teamTwoColor = action.payload;
    },
    resetTrue: (state) => {
      state.reset = true;
    },
    resetFalse: (state) => {
      state.reset = false;
    },
    updateScoreTemporaryData: (state, action) => {
      state.scoreTemporaryData.push(action.payload);
      state.cancelStep += 1;
      state.undoStep += 1;
    },
    updateScoreTemporaryDataOne: (state, action) => {
      state.scoreTemporaryData = [action.payload];
    },
    resetScoreTemporaryData: (state) => {

      state.scoreTemporaryData = [];
      // state.cancelStep += 1;
    },
    updatePostingData: (state, action) => {

      state.postingData.push(action.payload);
      state.cancelStep += 1;
      state.undoStep += 1;
    },
    updatePostingDataDeletedData: (state, action) => {
      state.postingData = [action.payload];
    },
    updateAllPostingDataStatusFailed: (state) => {
      state.postingData = state.postingData.map((item) => ({
        ...item,
        status: 'failed',
      }));
    },
    updatePostingDataReset: (state) => {
      state.postingData = [];
    },
    deletePostingData: (state, action) => {
      state.postingData = state.postingData.filter(
        (data) => !(data.unique_id === action.payload)
      );
    },
    updateSLNo: (state) => {
      state.sl_no += 1;
      state.cancelStep += 1;
      // state.undoStep += 1;
    },
    updateSLNoPayload: (state, action) => {
      state.sl_no = action.payload + 1;
    },
    updateMatchTeamOneRoster: (state, action) => {
      state.matchData.team_a_rosters = [...action.payload];
      state.cancelStep += 1;
      state.undoStep += 1;
    },
    updateMatchTeamTwoRoster: (state, action) => {
      state.matchData.team_b_rosters = [...action.payload];
      state.cancelStep += 1;
      state.undoStep += 1;
    },
    scoreLoadingTrue: (state) => {
      state.scoreDeleteLoading = true;
    },
    scoreLoadingFalse: (state) => {
      state.scoreDeleteLoading = false;
    },
    setQuarterOptions: (state, action) => {
      state.quarterOptions = action.payload;
    },
    matchStatusUpdate: (state, action) => {
      // Update the matchStatus in the state
      state.matchStatus = action.payload;
    },
    matchAllStatesReset: (state) => {
      // Reset match-related states to initial values
      state.quarter = "NotStarted";
      state.teamOneColor = "#419066";
      state.teamTwoColor = "#EA9036";
      state.matchStatus = "Waiting to start";
    },
    teamOneTargetPlayerList: (state, action) => {

      if (state.teamOneTargetPlayerList.includes(action.payload)) {
        state.teamOneTargetPlayerList = state.teamOneTargetPlayerList.filter(item => item !== action.payload);
      } else {
        state.teamOneTargetPlayerList.push(action.payload);
      }
    },
    teamTwoTargetPlayerList: (state, action) => {

      if (state.teamTwoTargetPlayerList.includes(action.payload)) {
        state.teamTwoTargetPlayerList = state.teamTwoTargetPlayerList.filter(item => item !== action.payload);
      } else {
        state.teamTwoTargetPlayerList.push(action.payload);
      }
    },
    teamOneDraggedPlayerList: (state, action) => {

      if (state.teamOneDraggedPlayerList.includes(action.payload)) {
        state.teamOneDraggedPlayerList = state.teamOneDraggedPlayerList.filter(item => item !== action.payload);
      } else {
        state.teamOneDraggedPlayerList.push(action.payload);
      }
    },
    teamTwoDraggedPlayerList: (state, action) => {

      if (state.teamTwoDraggedPlayerList.includes(action.payload)) {
        state.teamTwoDraggedPlayerList = state.teamTwoDraggedPlayerList.filter(item => item !== action.payload);
      } else {
        state.teamTwoDraggedPlayerList.push(action.payload);
      }
    },
    updateUndoStep: (state) => {
      state.undoStep = 0;
    },
    updateTeamOneOfficial: (state, action) => {
      state.teamOneOfficial = action.payload;
    },
    updateTeamTwoOfficial: (state, action) => {
      state.teamTwoOfficial = action.payload;
    },
    updateMatchTimeStatus: (state, action) => {
      state.matchData.game_status = { ...action.payload };
    },
    toggleShotClock: (state, action) => {
      state.shotClock = action.payload;
    },
    togglePossessionArrowTeamOne: (state, action) => {
      if (action.payload) {
        state.possessionArrowTeamOne = action.payload;
        state.possessionArrowTeamTwo = false;
      } else {
        state.possessionArrowTeamOne = !state.possessionArrowTeamOne;
        state.possessionArrowTeamTwo = false;
      }


    },
    togglePossessionArrowTeamTwo: (state, action) => {
      if (action.payload) {
        state.possessionArrowTeamTwo = action.payload;
        state.possessionArrowTeamOne = false;
      } else {
        state.possessionArrowTeamTwo = !state.possessionArrowTeamTwo;
        state.possessionArrowTeamOne = false;
      }

    },
    updateShotClockValue: (state, action) => {
      if (action.payload == "plus") {
        state.shotClockValue += 1;
      } else {
        if (state.shotClockValue > 0) {
          state.shotClockValue -= 1;
        }
      }
    },
    updateShotClockReset1: (state, action) => {
      if (action.payload == "plus") {
        if (state.shotClockReset1 < 24) {
          state.shotClockReset1 += 1;
        }
      } else {
        if (state.shotClockReset1 > 0) {
          state.shotClockReset1 -= 1;
        }
      }
    },
    updateShotClockReset2: (state, action) => {
      if (action.payload == "plus") {
        if (state.shotClockReset2 < 24) {
          state.shotClockReset2 += 1;
        }
      } else {
        if (state.shotClockReset2 > 0) {
          state.shotClockReset2 -= 1;
        }
      }
    },
    resetShotClockReset1: (state) => {
      state.shotClockReset1 = 0;
    },
    resetShotClockReset2: (state) => {
      state.shotClockReset2 = 0;
    },
    setJumpBallClockNewSeconds: (state, action) => {
      state.shotClockValue = action.payload;
    },
    resetJumpBallClockNewIsRunning: (state) => {
      state.jumpBallClock = false;
    },
    toggleTimeout: (state, action) => {
      state.timeout = action.payload;
    },
    setOpenStarterModal: (state, action) => {
      state.openStarterModal = action.payload;
    },
    setJumpBallTeamAPlayerRosterId: (state, action) => {
      state.jumpBallTeamAPlayerRosterId = action.payload;
    },
    setJumpBallTeamBPlayerRosterId: (state, action) => {
      state.jumpBallTeamBPlayerRosterId = action.payload;
    },
    resetJumpBallPlayers: (state) => {
      state.jumpBallTeamAPlayerRosterId = null;
      state.jumpBallTeamBPlayerRosterId = null;
    },
    onlyMatchDataUpdate: (state, action) => {
      // Preserve existing game_data and game_status
      const existingGameData = state.matchData?.game_data;
      const existingGameStatus = state.matchData?.game_status;

      // Update matchData with new data while keeping existing game_data and game_status
      state.matchData = {
        ...action.payload,
        game_data: existingGameData,
        game_status: existingGameStatus
      };
    },
    updateEventType: (state, action) => {
      if(action.payload == 12){
        state.eventType = "5x5";
      }else if(action.payload == 9){
        state.eventType = "3x3";
      } else {
        state.eventType = "5x5";
      }
    }

  },
});

export const {
  submitPlayersAndMatchData,
  made2PT,
  made3PT,
  made1PT,
  miss2PT,
  miss3PT,
  miss1PT,
  toPT,
  foulActions,
  playerSelectionTeamOne,
  playerSelectionTeamOneMiss,
  playerSelectionTeamTwo,
  playerSelectionTeamTwoMiss,
  shortFieldSelection,
  playerAssistSection,
  playerRebound,
  playerAssistSelection,
  teamOnePlayerDrop,
  teamTwoPlayerDrop,
  gameData,
  gameSubs,
  resetTeamOnePlaying,
  resetTeamTwoPlaying,
  quarterOptions,
  selectedQuarter,
  teamOneColorSet,
  teamTwoColorSet,
  resetTrue,
  resetFalse,
  updateScoreTemporaryData,
  updateScoreTemporaryDataOne,
  resetScoreTemporaryData,
  updatePostingData,
  updatePostingDataDeletedData,
  updateAllPostingDataStatusFailed,
  updatePostingDataReset,
  deletePostingData,
  updateSLNo,
  updateSLNoPayload,
  updateMatchTeamOneRoster,
  updateMatchTeamTwoRoster,
  scoreLoadingTrue,
  scoreLoadingFalse,
  setQuarterOptions,
  startAction,
  updateTeamOneLastPlayerIsPlaying,
  updateTeamTwoLastPlayerIsPlaying,
  updateCancelTeamOnePlayerPlayingStatus,
  updateCancelTeamTwoPlayerPlayingStatus,
  updateTeamOnePlayerPlayingStatus,
  updateTeamTwoPlayerPlayingStatus,
  matchStatusUpdate,
  matchAllStatesReset,
  teamOneTargetPlayerList,
  teamTwoTargetPlayerList,
  teamOneDraggedPlayerList,
  teamTwoDraggedPlayerList,
  updateUndoStep,
  updateTeamOneOfficial,
  updateTeamTwoOfficial,
  updateMatchTimeStatus,
  toggleShotClock,
  togglePossessionArrowTeamOne,
  togglePossessionArrowTeamTwo,
  updateShotClockValue,
  updateShotClockReset1,
  updateShotClockReset2,
  resetShotClockReset1,
  resetShotClockReset2,
  setJumpBallClockNewSeconds,
  toggleTimeout,
  submitPlayersAndMatchDataWithOutPlaySec,
  setOpenStarterModal,
  setJumpBallTeamAPlayerRosterId,
  setJumpBallTeamBPlayerRosterId,
  resetJumpBallPlayers,
  onlyMatchDataUpdate,
  updateEventType
} = playersSlice.actions;

export default playersSlice.reducer;
